import styled from 'styled-components';

import Button from '@components/Button';

export const StyledPriceRangeFilter = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 8px;

  .listing-filters-accommodation-input,
  .listing-filters-accommodation-input input {
    border: none;
    outline: none;
    width: auto;
    min-width: 1em;
    background-color: transparent;
    color: ${({ theme }) => theme.palette.grey1100};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  .setur-input-number-handler-wrap {
    display: none;
  }

  .setur-input-number-input-wrap,
  .setur-input-number-input-wrap input {
    height: 100%;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 12px;

    .listing-filters-accommodation-input {
      width: 100%;
      height: 100%;
    }
  }
`;

export const PriceRangeInputLabel = styled.span`
  display: block;
  width: fit-content;
  height: 15px;
  margin: 0 0 1px;
  font-size: 10px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.grey700};
  transition: all 0.5s;
`;

export const PriceRangeInputBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const PriceRangeInputWrapper = styled.div<{ isError?: boolean }>`
  width: 100%;
  border-radius: 8px;
  border: ${({ isError, theme }) =>
    isError
      ? 'solid 2px #d95c5c'
      : `solid 1px ${theme.palette.inputBorderColor}`};
  background-color: ${({ theme }) => theme.palette.inputBackgroundColor};
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.grey1100};
  }
`;

export const PriceRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PriceRangeWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  grid-template-rows: 40px;
  grid-auto-rows: 40px;
  grid-gap: 10px;
`;

export const PriceRangeButton = styled(Button)`
  width: 100%;
  margin: 10px 0 0;
  height: 44px !important;
  color: ${({ theme }) => theme.palette.tomato};
  font-weight: 700;
  font-size: 14px !important;
  border: solid 1px ${({ theme }) => theme.palette.tomato};
  border-radius: 8px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 16px;
`;

export const CollapseTitle = styled(Title).attrs({ as: 'span' })`
  margin-bottom: 0;
`;

export const ErrorMessage = styled.div`
  margin-top: 5px;
  padding: 10px 5px;
  font-size: 10px;
  background-color: #f98a89;
  color: ${({ theme }) => theme.palette.white};
  font-weight: bold;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px 20px;
    margin: 10px 15px;
  }
`;
